
import { Component } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
    selector: 'app-generic',
    imports: [],
    providers: [BsModalService],
    templateUrl: './generic.component.html',
    styleUrl: './generic.component.css'
})
export class GenericComponent {
  title?: string;
  closeBtnName?: string;
  list: string[] = [];

  constructor(public bsModalRef: BsModalRef) {}
 
  ngOnInit() {
    //this.list.push('PROFIT!!!');
  }
  close() {
    console.log("Cerrando modal.");
    this.bsModalRef.hide();
  }
}
